export enum TipoDaAgendaDoMural {
  Compacto = 'compacto',
  Completo = 'completo'
}
